import { defineMessages } from 'react-intl';

export default defineMessages({
  workflowTransitionIssues: {
    id: 'frontbucket.repository.pullRequest.merge.workflowTransitionIssues',
    description: 'Label for jira issues which the workflow will update',
    defaultMessage:
      'Workflow issue {issueCount, plural, one {transition} other {transitions}}',
  },
  workflowTransitionInfo: {
    id: 'frontbucket.repository.pullRequest.merge.workflowTransitionInfo',
    description: 'Tooltip for workflow transition info icon',
    defaultMessage:
      'Merging this pull request will trigger the following issue {issueCount, plural, one {transition} other {transitions}} in your Jira workflow.',
  },
  transitionIssues: {
    id: 'frontbucket.repository.pullRequest.merge.transitionIssues',
    description: 'Label for jira issues which the user wants to update',
    defaultMessage:
      'Transition {issueCount, plural, one {issue} other {issues}}',
  },
  transitionAdditional: {
    id: 'frontbucket.repository.pullRequest.merge.transitionAdditional',
    description:
      'Message to indicate that users should access Jira via the sidebar to manage more issues',
    defaultMessage:
      'To perform additional transitions, open linked Jira issues from the pull request sidebar after merging.',
  },
  fetchTransitionsFailed: {
    id: 'frontbucket.repository.pullRequest.merge.fetchTransitionsFailed',
    description:
      'Message indicating that fetching the available transitions failed',
    defaultMessage: "We can't load the issue transition section.",
  },
  tryAgain: {
    id: 'frontbucket.repository.pullRequest.merge.tryAgain',
    description: 'Text for a retry button to fetch transitions',
    defaultMessage: 'Try again',
  },
});
